<template>
  <div class="hello">
    <div class="l-btn">立即开通</div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
}
h2 {
  font-size: 22px;
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue